import BonusView from "@/views/admin/BonusView.vue";
import AdminLevels from "@/views/admin/Levels.vue";
import SalaryView from "@/views/admin/SalaryView.vue";
import SalesOrders from "@/views/admin/SalesOrders.vue";
import StackOrders from "@/views/admin/StackOrders.vue";
import AdminTeams from "@/views/admin/Teams.vue";
import UserDetailsView from "@/views/admin/UserDetailsView.vue";
import Clear from "@/views/Clear.vue";
import MyTeam from "@/views/TeamManager/MyTeam.vue";
import UserMonthly from "@/views/user/UserMonthly.vue";
import Vue from "vue";
import Router from "vue-router";
import store from "./store/store";
import CustomerHours from "./views/admin/CustomerHours.vue";
import AdminTariffs from "./views/admin/Tariffs.vue";
import AdminSummary from "./views/admin/UserHours.vue";
import AdminUserSettings from "./views/admin/UserSettings.vue";
import AdminConsultantLevels from "./views/admin/ConsultantLevels.vue";
import Home from "./views/Home.vue";
import StakeholdersOverview from "./views/stakeholders/Overview.vue";
import Token from "./views/Token.vue";
import Calendar from "./views/user/Calendar.vue";
import LevelData from "./views/user/LevelData.vue";
import VacationPlanner from "./views/VacationPlanner.vue";
import InvoiceView from "./views/admin/InvoiceView.vue";
//@ts-ignore
import { AuthenticationContext } from "vue-adal";
Vue.use(Router);
const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "Home",
            component: Home,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant"],
            },
        },
        {
            path: "/clear",
            name: "Clear",
            component: Clear,
            meta: {
                requireAuth: false,
            },
        },
        {
            path: "/stakeholder/hours",
            name: "StakeholdersOverview",
            component: StakeholdersOverview,
            meta: {
                requireAuth: true,
                requireRoles: ["Stakeholder", "Admin"],
            },
        },
        {
            path: "/calendar",
            name: "calendar",
            component: Calendar,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant"],
            },
        },
        {
            path: "/monthlySummary",
            name: "monthlySummary",
            component: UserMonthly,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant"],
            },
        },
        {
            path: "/vacation",
            name: "VaccationPlanner",
            component: VacationPlanner,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant"],
            },
        },
        {
            path: "/token",
            name: "Token",
            component: Token,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant", "Stakeholder"],
            },
        },
        {
            path: "/admin/customerHours",
            name: "customerHours",
            component: CustomerHours,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/userHours",
            name: "adminSummary",
            component: AdminSummary,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/details/:user",
            name: "UserDetailsView",
            component: UserDetailsView,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/salaryView",
            name: "salaryView",
            component: SalaryView,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/invoiceView",
            name: "InvoiceView",
            component: InvoiceView,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "Director"],
            },
        },
        {
            path: "/admin/bonusView",
            name: "bonusView",
            component: BonusView,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin"],
            },
        },
        {
            path: "/admin/levels",
            name: "AdminLevels",
            component: AdminLevels,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/LevelData",
            name: "LevelData",
            component: LevelData,
            meta: {
                requireAuth: true,
                requireRoles: ["Employee", "Consultant"],
            },
        },
        {
            path: "/admin/userSettings",
            name: "AdminUserSettings",
            component: AdminUserSettings,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/tariffs",
            name: "AdminTariffs",
            component: AdminTariffs,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/teams",
            name: "AdminTeams",
            component: AdminTeams,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/consultant-levels",
            name: "AdminTeams",
            component: AdminConsultantLevels,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/teammanager/overview",
            name: "MyTeam",
            component: MyTeam,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "TeamManager", "Director"],
            },
        },
        {
            path: "/admin/salesOrders",
            name: "SalesOrders",
            component: SalesOrders,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "Director"],
            },
        },
        {
            path: "/admin/stackOrders",
            name: "StackOrders",
            component: StackOrders,
            meta: {
                requireAuth: true,
                requireRoles: ["Admin", "Director"],
            },
        },
    ],
});
router.beforeEach((to, from, next) => {
    //console.log("to",to)
    //console.log("from",from)
    if (to.matched.some((record) => record.meta.requireAuth)) {
        if (AuthenticationContext.isAuthenticated()) {
            // Authenticated, make sure roles are okay
            let checkRoles = [];
            if (to.matched.some((record) => {
                if (record.meta.requireRoles) {
                    checkRoles = checkRoles.concat(record.meta.requireRoles);
                    //console.log(checkRoles)
                    return true;
                }
                return false;
            })) {
                if (AuthenticationContext.checkRoles(checkRoles)) {
                    // Authorized to see the page
                    //console.log("checking roles", checkRoles)
                    next();
                }
                else {
                    // Not authorized to see page
                    console.log("Not Authorized");
                    store.dispatch("ToastMessage", {
                        type: "error",
                        message: "You do not have the correct role to access the route " + to.name,
                    });
                    if (from.fullPath !== to.fullPath) {
                        console.log("denna");
                        next(from.fullPath);
                    }
                }
            }
            else {
                next();
            }
        }
        else {
            AuthenticationContext.login();
        }
    }
    else {
        next();
    }
});
export default router;
